import { gql } from '@apollo/client';

export const PROPERTY_DELETED = gql`
  subscription propertyDeleted {
    propertyDeleted {
      id
    }
  }
`;
